import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FlightCrewSummaryResponse } from '../models/FlightCrewItem';

export interface SeatAvailabilityItem {
  flightNumber: string;
  availableSeats?: number | null;
  standbySummary?: FlightCrewSummaryResponse | null;
  /** Kept for backward compat with code that reads standbyCount from ticket. Total = totalLatam + totalExternal. */
  standbyCount?: number | null;
  originLocationCode?: string;
  destinationLocationCode?: string;
  departure?: string;
  arrival?: string;
}

@Component({
  selector: 'app-seat-availability',
  templateUrl: './seat-availability.component.html',
  styleUrls: ['./seat-availability.component.scss'],
  standalone: false
})
export class SeatAvailabilityComponent {
  @Input() items: SeatAvailabilityItem[] = [];
  /**
   * Search results: the count is its own element ("6") followed by the unit ("assentos") in a
   * separate span, so a dense layout can hide the unit. The full sentence stays in the accessible name.
   */
  @Input() compactCount = false;

  @Output() standbyClicked = new EventEmitter<FlightCrewSummaryResponse>();

  labelFor(item: SeatAvailabilityItem, index: number): string {
    const leg = `Trecho ${index + 1}`;
    const seats = item.availableSeats;
    if (seats === undefined) return `${leg}, consultando disponibilidade`;
    if (seats === null) return `${leg}, indisponível`;
    if (seats <= 0) return `${leg}, sem assentos`;
    return `${leg}, ${seats} ${seats === 1 ? 'assento disponível' : 'assentos disponíveis'}`;
  }

  /** Positive counts can drop the word "assentos"; the other states keep their full label. */
  countText(item: SeatAvailabilityItem): number | null {
    return this.compactCount && typeof item.availableSeats === 'number' && item.availableSeats > 0
      ? item.availableSeats
      : null;
  }

  standbyTotal(item: SeatAvailabilityItem): number {
    if (!item.standbySummary) return 0;
    return (item.standbySummary.totalLatam ?? 0) + (item.standbySummary.totalExternal ?? 0);
  }

  openStandbyDetail(summary: FlightCrewSummaryResponse): void {
    this.standbyClicked.emit(summary);
  }
}
